import { LinksSchemaType } from "../type";

export const busLinksArray: LinksSchemaType = {
  main: "/bus",
  maintitle: "صفحه اصلی اتوبوس ",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/bus-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/bus-mobile.png`,
  otherlinks: [
    {
      title: "اتوبوس اصفهان تهران",
      href: "/bus/Esfahan/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/isfahan-tehran.png`
    },
    {
      title: "اتوبوس تهران اصفهان",
      href: "/bus/Tehran/Esfahan",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-isfahan.png`
    },
    {
      title: "اتوبوس تبریز تهران",
      href: "/bus/Tabriz/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tabriz-tehran.png`
    },
    {
      title: "اتوبوس تهران تبریز",
      href: "/bus/Tehran/Tabriz",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-tabriz.png`
    },
    {
      title: "اتوبوس مشهد تهران",
      href: "/bus/Mashhad/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mashhad-tehran.png`
    },
    {
      title: "اتوبوس تهران مشهد",
      href: "/bus/Tehran/Mashhad",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-mashhad.png`
    },
    {
      title: "اتوبوس رشت تهران",
      href: "/bus/Rasht/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/rasht-tehran.png`
    },
    {
      title: "اتوبوس تهران رشت",
      href: "/bus/Tehran/Rasht",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-rasht.png`
    }
  ]
};
